import React from 'react';
import './Particles.css';

const Particles = () => {
    return (
        <div className="particles__wrapper">
            <div className="glowing">
                <span className="particle-span-1"></span>
                <span className="particle-span-2"></span>
                <span className="particle-span-3"></span>
            </div>
            <div className="glowing">
                <span className="particle-span-1"></span>
                <span className="particle-span-2"></span>
                <span className="particle-span-3"></span>
            </div>
            <div className="glowing">
                <span className="particle-span-1"></span>
                <span className="particle-span-2"></span>
                <span className="particle-span-3"></span>
            </div>
            <div className="glowing">
                <span className="particle-span-1"></span>
                <span className="particle-span-2"></span>
                <span className="particle-span-3"></span>
            </div>
        </div>
    )
}

export default Particles
